import React from "react";
import { ExternalLink, Phone, Reply } from "lucide-react";

export interface TemplateButton {
    type: "QUICK_REPLY" | "URL" | "PHONE_NUMBER" | string;
    text: string;
    url?: string | null;
    phone_number?: string | null;
}

interface TemplateBubbleProps {
    headerText?: string;
    bodyText?: string;
    footerText?: string;
    headerParams?: string[];
    bodyParams?: string[];
    buttons?: TemplateButton[];
    renderButtonExtra?: (button: TemplateButton, idx: number) => React.ReactNode;
    onClick?: () => void;
}

const substitute = (text: string = "", params: string[] = []): string => {
    return text.replace(/\{\{\s*(\d+)\s*\}\}/g, (_, n) => {
        const val = params[Number(n) - 1];
        return val != null && val !== "" ? val : `{{${n}}}`;
    });
};

const TemplateBubble: React.FC<TemplateBubbleProps> = ({
    headerText,
    bodyText,
    footerText,
    headerParams,
    bodyParams,
    buttons,
    renderButtonExtra,
    onClick,
}) => {
    const header = headerText ? substitute(headerText, headerParams) : "";
    const body = bodyText ? substitute(bodyText, bodyParams) : "";
    const visibleButtons = Array.isArray(buttons) ? buttons : [];

    return (
        <div
            onClick={onClick}
            style={{
                background: "#ffffff",
                border: "1px solid #d1fae5",
                borderLeft: "3px solid #10b981",
                borderRadius: "8px 8px 8px 0",
                boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                padding: "8px 10px",
                maxWidth: "260px",
                cursor: onClick ? "pointer" : "default",
            }}
        >
            {header && (
                <div style={{ fontSize: "13px", fontWeight: 700, color: "#111827", marginBottom: "4px" }}>
                    {header}
                </div>
            )}
            {body && (
                <div style={{ fontSize: "12px", color: "#1f2937", lineHeight: 1.45, whiteSpace: "pre-wrap" }}>
                    {body}
                </div>
            )}
            {footerText && (
                <div style={{ fontSize: "10px", color: "#6b7280", fontStyle: "italic", marginTop: "6px" }}>
                    {footerText}
                </div>
            )}
            {visibleButtons.length > 0 && (
                <div style={{ marginTop: "8px", borderTop: "1px solid #f1f5f9", paddingTop: "4px" }}>
                    {visibleButtons.map((btn, idx) => {
                        const Icon = btn.type === "URL" ? ExternalLink : btn.type === "PHONE_NUMBER" ? Phone : Reply;
                        return (
                            <div
                                key={idx}
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "6px 4px",
                                    borderTop: idx === 0 ? "none" : "1px solid #f8fafc",
                                    fontSize: "11px",
                                    color: "#2563eb",
                                }}
                            >
                                <Icon size={11} />
                                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {btn.text}
                                </span>
                                {renderButtonExtra && renderButtonExtra(btn, idx)}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TemplateBubble;
